<template>
    <div>
        <div ref="card" class="card pl-0 py-0 is-clickable" :class="cardClassess" @mouseover="$emit('hover', content)"
            @mouseleave="$emit('leave', content)">
            <div @click.stop="openObject($event.target.value)">
                <div class="lb-card-content">
                    <div class="columns is-vcentered mx-0 my-0 is-mobile">
                        <div class="column is-narrow px-0 py-0 is-shrinkable has-text-centered">
                            <div class="icon is-large has-text-white"><i class="mdi mdi-24px" :class="objectType"></i>
                            </div>
                        </div>
                        <div class="column is-shrinkable has-background-white px-4 py-4 my-1 mr-1">

                            <p class="
                                        card-header-title
                                        title
                                        is-size-5 is-block
                                        is-marginless
                                    ">
                                {{ content.title }}
                            </p>
                            <div @click.stop.prevent="" class="dropdown is-right is-hoverable object-menu"
                                v-if="!isCreation && !isEdition">
                                <span class="
                                            icon
                                            is-small
                                            dropdown-trigger
                                            has-text-black
                                            mt-1
                                        ">
                                    <i class="mdi mdi-24px mdi-dots-vertical" aria-hidden="true" />
                                </span>
                                <div class="dropdown-menu" role="menu">
                                    <div class="dropdown-content">
                                        <div class="dropdown-item" @click.stop.prevent="$emit('view')">
                                            <a v-t="'dropdown_option_view_object'" />
                                        </div>
                                        <div v-if="canDelete" class="dropdown-item"
                                            @click.stop.prevent="$emit('remove')">
                                            <a v-t="'dropdown_option_delete_object'" />
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

import _ from 'underscore';
export default {
    name: 'ObjectCardBasic',
    components: {},
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        isCreation: { type: Boolean, default: false },
        isEdition: { type: Boolean, default: false },
        index: {
            type: Number,
            default: 1
        },
        selectedObject: {
            type: String,
            default: undefined,
        },
        canCreateOrEditObjects: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            resizeObserver: new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.$emit('resize');
                }
            }),
        };
    },
    computed: {
        objectType() {
            switch (this.content.type) {
                case "object":
                    return "mdi-text-box-outline";
                case "question":
                    return "mdi-help";
                case "clue":
                    return "mdi-paw";
            }
        },
        isSelected() {
            return this.selectedObject == this.content._id;
        },
        canDelete() {
            return this.content.accessLevel == 'administrator' || this.$store.getters.project.accessLevel == 'administrator' || this.$store.getters.isAdmin;
        },
        cardClassess() {
            let classes = "";
            switch (this.content.type) {
                case "object":
                    classes += " has-background-eduloc-blue";
                    break;
                case "question":
                    classes += " has-background-eduloc-orange";
                    break;
                case "clue":
                    classes += " has-background-primary";
                    break;
            }
            if ((this.selectedObject || this.isCreation) && !this.isSelected) {
                classes += " disabled"
            }
            return classes;
        }
    },
    mounted() {
        this.resizeObserver.observe(this.$refs.card);
    },
    destroyed() {
        this.resizeObserver.disconnect();
    },
    methods: {
        openObject(object) {
            if(this.$store.getters.project && this.$store.getters.project.accessLevel=='read' && (this.isCreation || this.isEdition || !this.canCreateOrEditObjects)){
                this.$emit('view',object)
            }
            if (this.isCreation || this.isEdition || !this.canCreateOrEditObjects) {
                return;
            }
            this.$emit('click', object);
        }
    },
};
</script>

<style scoped>
    .card-header-title {
        overflow-wrap: break-word;
        padding: 0 1rem;
    }
    .lb-card-content>*+* {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .object-menu {
        position: absolute;
        right: 10px;
        top: 17px;
    }
    .card.disabled {
        opacity: 0.5;
        cursor: not-allowed !important;
    }
    .object-menu .dropdown-content {
        padding: 0;
    }
    .object-menu .dropdown-item a {
        font-family: var(--primary-font);
        font-weight: normal;
        width: 100%;
        display: block;
    }
    .object-menu .dropdown-item a:hover,
    .object-menu .dropdown-item:hover {
        background-color: var(--eduloc-red);
        color: #FFFFFF;
    }
    .object-menu .dropdown-item:hover a {
        color: #FFFFFF;
    }
</style>
